import React from 'react'
import { motion } from 'framer-motion'
import {
  FiDownload,
  FiCalendar,
  FiBriefcase,
  FiBook,
  FiAward,
} from 'react-icons/fi'
import './Resume.css'

const Resume = () => {
  const experience = [
    {
      role: 'PGT North Sales Operations Resource',
      company: 'PepsiCo',
      date: 'May 2024 - February 2026',
      location: 'Remote/Travel',
      description:
        'Analyzed operational and system discrepancies across SAP platforms, supporting resolution of workflow and data issues impacting order processing, inventory, and delivery accuracy. Collaborated with logistics, warehouse operations, finance, and business stakeholders to identify process gaps and implement operational improvements. Utilized SAP and Excel reporting tools to validate data accuracy, analyze trends, and support operational decision-making.',
    },
    {
      role: 'Contract Operations Customer Service',
      company: 'PepsiCo',
      date: 'October 2022 - May 2024',
      location: 'Purchase, NY',
      description:
        'Conducted root cause analysis on operational and transactional discrepancies to improve workflow accuracy and efficiency. Managed reconciliation and transactional adjustments within SAP systems while maintaining data integrity and compliance standards. Partnered with finance, logistics, and operations teams to resolve process and system-related issues.',
    },
    {
      role: 'Clinical Quality Analyst',
      company: 'SunRiver Health Center',
      date: 'July 2011 - September 2022',
      location: 'Peekskill, NY',
      description:
        'Analyzed healthcare and clinical quality data to support regulatory reporting, compliance initiatives, and performance improvement efforts. Generated reports and dashboards to identify trends in patient outcomes, utilization, and operational performance. Collaborated with clinical leadership and operational stakeholders to improve reporting accuracy and workflow efficiency.',
    },
  ]

  const education = [
    {
      degree: 'Bachelor of Arts in Accounting',
      school: 'Lehman College',
      year: '2020',
    },
  ]

  const certifications = [
    {
      title: 'SQL for Data Science',
      issuer: 'Coursera',
      year: '2026',
      icon: FiAward,
    },
    {
      title:
        'SAP Certified Associate – SAP S/4HANA Sourcing & Procurement (MM)',
      issuer: 'SAP',
      year: '2026',
      icon: FiAward,
    },
    {
      title: 'ECBA (Entry Certificate in Business Analysis)',
      issuer: 'IIBA',
      year: 'Pursuing',
      icon: FiAward,
    },
  ]

  return (
    <section id="resume" className="resume section light">
      <div className="container">
        <h2 className="section-title">Resume & Experience</h2>

        <div className="resume-content">
          <motion.div
            className="resume-preview"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="resume-placeholder">
              <div className="placeholder-icon">📄</div>
              <p>Brian Rodricks</p>
              <p className="contact-info">(914) 539-2131 • Peekskill, NY</p>
              <p className="contact-info">brrodricks@gmail.com</p>
            </div>
            <motion.button
              className="download-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() =>
                window.open('/brian_rodricks_resume_2026.pdf', '_blank')
              }
            >
              <FiDownload /> Download Resume
            </motion.button>
          </motion.div>

          <div className="timeline">
            <motion.div
              className="timeline-section"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h3>
                <FiBriefcase /> Experience
              </h3>
              <div className="timeline-items">
                {experience.map((item, index) => (
                  <motion.div
                    key={index}
                    className="timeline-item"
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    <div className="timeline-marker" />
                    <div className="timeline-content">
                      <h4>{item.role}</h4>
                      <p className="company">{item.company}</p>
                      <p className="location">{item.location}</p>
                      <p className="date">
                        <FiCalendar /> {item.date}
                      </p>
                      <p className="description">{item.description}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            <motion.div
              className="timeline-section"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h3>
                <FiBook /> Education
              </h3>
              <div className="timeline-items">
                {education.map((item, index) => (
                  <motion.div
                    key={index}
                    className="timeline-item"
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    <div className="timeline-marker" />
                    <div className="timeline-content">
                      <h4>{item.degree}</h4>
                      <p className="company">{item.school}</p>
                      <p className="date">{item.year}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            <motion.div
              className="timeline-section"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <h3>
                <FiAward /> Certifications
              </h3>
              <div className="timeline-items">
                {certifications.map((item, index) => (
                  <motion.div
                    key={index}
                    className="timeline-item"
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    <div className="timeline-marker" />
                    <div className="timeline-content">
                      <h4>{item.title}</h4>
                      <p className="company">{item.issuer}</p>
                      <p className="date">{item.year}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Resume
